import type { JSX } from 'react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';

// Root route — Provider plumbing (QueryClient, IntlProvider) lives in
// `src/main.tsx` so it surrounds the RouterProvider; this file is the
// minimum layout shell for every route below it.
//
// `createRootRouteWithContext` lets child loaders read the QueryClient
// from `route.context` so they can prefetch through TanStack Query.

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout(): JSX.Element {
  return (
    <div className="min-h-full">
      <Outlet />
    </div>
  );
}
